var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine1000 = function SvgLandingLine1000(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 1085,
    fill: "none",
    className: "landing-line-1000_svg__landing-line-1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M57.5.213v61.773c0 8.324.806 16.629 2.406 24.798l4.688 23.934A129 129 0 0 1 67 135.515v125.928c0 15.562 2.991 30.978 8.811 45.411a121.4 121.4 0 0 1 8.811 45.411v117.254a76.27 76.27 0 0 1-41.31 67.786A76.27 76.27 0 0 0 2 605.091V710.33c0 23.472 19.028 42.5 42.5 42.5S87 771.858 87 795.33v112.45c0 21.92-6.433 43.358-18.5 61.657A112 112 0 0 0 50 1031.09V1085"
  })));
};
export default SvgLandingLine1000;